import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center text-xl"
}
const _hoisted_2 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationDialog, {
      title: "Xác nhận",
      size: "sm",
      "is-display": _ctx.isDeleteKhoConfirmationDialogDisplay,
      onOnConfirmButtonClick: _ctx.confirmDelete,
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDeleteKhoConfirmationDialogDisplay = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDeleteKhoConfirmationDialogDisplay = false))
    }, {
      default: _withCtx(() => [
        (_ctx.deletingKho)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, [
              _createTextVNode(" Bạn hãy chắc chắn muốn xóa kho "),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.deletingKho.ten_kho), 1),
              _createTextVNode("? ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _createVNode(_component_el_table, {
      "max-height": "800",
      style: {"width":"100%"},
      size: "medium",
      border: true,
      data: _ctx.items
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "ID",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.id), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Tên" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ten_kho), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Mã",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ma_kho), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Địa chỉ",
          width: "300"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.dia_chi), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Ghi chú" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ghi_chu), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          width: "50",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_Setting, {
              actions: _ctx.getSettingActions(scope.row)
            }, null, 8, ["actions"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ], 64))
}